import { Row } from '@tanstack/react-table'

import { Log } from '@/types/logs'
import { sortLogsByTime } from './sortLogsByTime'
import { checkIsLogUnfinished } from './checkIsLogUnfinished'

export const sortLogsByUnfinished = (rowA: Row<Log>, rowB: Row<Log>): number => {
    const logAUnfinished = checkIsLogUnfinished(rowA.original)
    const logBUnfinished = checkIsLogUnfinished(rowB.original)

    if (logAUnfinished && logBUnfinished) {
        return sortLogsByTime(rowA.original, rowB.original)
    }

    if (logAUnfinished && !logBUnfinished) return -1
    if (logBUnfinished && !logAUnfinished) return 1

    return 0
}
